import PropTypes from "prop-types";
import { useFormContext, Controller } from "react-hook-form";
import {
  FormControl,
  FormHelperText,
  TextField,
  Autocomplete,
} from "@mui/material";

RHFSearchableSelectField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  options: PropTypes.array.isRequired,
  variant: PropTypes.string,
  disableOptions: PropTypes.array,
  size: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  maxHeight: PropTypes.number,
  enableNoneSelect: PropTypes.bool,
};

function RHFSearchableSelectField({
  name,
  options = [],
  variant,
  label,
  disableOptions = [],
  size = 'small',
  width = 150,
  maxHeight = 300,
  enableNoneSelect = false,
  hideNoneHint = false,
  noOptionsText = 'No options',
  mt = 0,
  mb = 0,
  ...other
}) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <FormControl error={!!error} sx={{ minWidth: width, mt, mb }} size={size} fullWidth>
          <Autocomplete
            value={options.find(option => option.value === value) || null}
            onChange={(event, item) => {
              onChange(item ? item.value : '');
            }}
            options={options}
            getOptionDisabled={(option) =>
              disableOptions.includes(option.value)
            }
            getOptionLabel={(option) => option.label}
            renderOption={(props, option) => (
              <li {...props} style={{ color: 'black', fontSize: 12, padding: '4px 12px', borderBottom: '1px solid #f0f0f0' }}>
                {option.label}
              </li>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                label={label}
                variant={variant || "outlined"}
                error={!!error}
                helperText={error?.message}
                size={size}
                InputLabelProps={{
                  ...params.InputLabelProps,
                  sx: {
                    fontSize: 10,
                    // '&:not(.MuiInputLabel-shrink)': {
                    //   transform: 'translate(14px, 12px) scale(1)',
                    // },
                  },
                }}
                InputProps={{
                  ...params.InputProps,
                  sx: { fontSize: 12 },
                }}
                {...other}
              />
            )}
            noOptionsText={noOptionsText}
            fullWidth
            size={size}
            ListboxProps={{ style: { maxHeight } }}
          />
          {enableNoneSelect && !hideNoneHint && <FormHelperText sx={{ fontSize: 12 }}>Select "None" for no selection.</FormHelperText>}
        </FormControl>
      )}
    />
  );
}

export default RHFSearchableSelectField;

